const baseAction = "COMPANY";

export function SetValue(name, value) {
	return (dispatch) => {
		let keyPath = name;

		if (typeof name === "string") {
			keyPath = [name];
		}

		dispatch({ type: `${baseAction}:UPDATE`, keyPath, value });
	};
}

export function ResetFields() {
	return (dispatch) => {
		dispatch({ type: `${baseAction}:RESETFIELDS` });
	};
}
